import { State } from '.';
import { LabTestCode } from '../../models/lab-test-code';

export const selectors = {
    getLabTestCode: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<LabTestCode> => state.byId[id || ''],
    getLabTestCodeIds: (
        state: State
    ): string[] => state.allIds
};
